module.exports = __webpack_public_path__ + "img/img_throw_2@2x_v2.fb29f25b.png";